import styled from 'styled-components';

export const StyledNewMedicineView = styled.div`
   display: grid;
   grid-template-columns: 1fr 70px 200px 24px;
   gap: 32px;
   align-items: center;
   margin-top: 4px;
`;

StyledNewMedicineView.displayName = 'StyledNewMedicineView';
